export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/proofreading_editing.d2189a7.svg";